// Корневой маршрут `/` — развилка по роли, а не экран.
//
// Здесь была заглушка каркаса («Экраны появятся в задачах T-001…T-007») с внутренними
// номерами задач, дожившая до конца Phase 3 и видимая пользователю. Своего содержания
// у корня нет и не должно быть: каждая роль начинает с разного экрана (app.md §6),
// и корень обязан просто отвести туда.

import { Navigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { startScreenFor } from '@/modules/auth';
import { t } from '@/shared/i18n';
import { useSession } from '@/shared/session';

export function StartPage(): ReactElement {
  const session = useSession();

  if (session.data) {
    // `replace`, а не push: корень не должен оставаться в истории, иначе «Назад»
    // возвращает на редирект и снова уводит вперёд — навигация зацикливается.
    return <Navigate to={startScreenFor(session.data)} replace />;
  }

  // Профиль ещё грузится. Показывать нечего, но и белый экран без объяснения
  // на медленном моноблоке читается как «приложение сломалось».
  return (
    <main data-testid="start-route">
      <p>{t('common.loading')}</p>
    </main>
  );
}
